import ButtonGroup from "react-bootstrap/ButtonGroup";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { de } from "date-fns/locale/de";
registerLocale("de", de);

import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";

import { api } from "./pureFunctions"
import StatistikZeitverlauf from "./StatistikZeitverlauf";

const host = import.meta.env.PROD ? "" : "http://localhost:8080";

function StatistikActivity({ }) {
  const [activityStats, setActivityStats] = useState();
  const [endDate, setEndDate] = useState(new Date());
  const [startDate, setStartDate] = useState(() => {
    const before = new Date();
    return new Date(before.setDate(before.getDate() - 7));
  });
  const onDateRangeChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    console.log("change: " + start + " " + end);
    if (end) getActivitydata(start, end);
  };
  //ind_3064_Feld_adressen86 leadart
  //ind_3070_Feld_adressen88 veranstaltungsdatum
  //ind_2576_Feld_adressen73 akquisestufe
  const [activityFilter, setActivityFilter] = useState({
    Termin: true,
    Telefonat: true,
    Email: true,
    Bewertungsmappentermin: true,
    Akquiseanruf_nicht_erreicht: true,
    Akquiseanruf_erreicht: true,
    Einkaufstermin: true,
  });

  useEffect(() => {
    getActivitydata(startDate, endDate);
  }, []);

  function parseDateforoO(inputdate) {
    let newdate = new Date(inputdate);
    var year = newdate.getFullYear();
    var month = newdate.getMonth() + 1;
    if (month <= 9) month = "0" + month;
    var day = newdate.getDate();
    if (day <= 9) day = "0" + day;

    return (
      year + "-" + month + "-" + day + " " + newdate.toLocaleTimeString("de")
    );
  }

  function getActivitydata(start, end) {
    const parameters = {
      filter: {
        Benutzer_nr: [
          {
            op: "IN",
            val: ["199", "209", "203", "143"], //Linkh,Schimminger, Rahimi, Halder "187" //JOM
          },
        ],
        Aktionsart: [
          {
            op: "IN",
            val: ["Termin", "Telefonat", "Email"],
          },
        ],
        // created: [{ "op": "BETWEEN", "val": [req.body.startDate, req.body.endDate] }]
        created: [
          { op: "BETWEEN", val: [parseDateforoO(start), parseDateforoO(end)] },
        ],
      },
      data: [
        "Objekt_nr",
        "Adress_nr",
        "Aktionsart",
        "Aktionstyp",
        "Datum",
        "created",
        "Benutzer",
      ],
    };

    api
      .post("/api/getakquiseactivity", { parameters: parameters })
      .then((data) => {
        console.log(data);

        let sortedactivity = {};
        sortedactivity.chalder = data.data.filter(
          (item) =>
            item.Benutzer === "CHalder" || item.Benutzer === "Claudia Halder"
        );
        sortedactivity.dlinkh = data.data.filter(
          (item) =>
            item.Benutzer === "DLinkh" || item.Benutzer === "Dennis Linkh"
        );
        sortedactivity.tschimminger = data.data.filter(
          (item) =>
            item.Benutzer === "TSchimminger" ||
            item.Benutzer === "Thomas Schimminger"
        );
        sortedactivity.shrahimi = data.data.filter(
          (item) =>
            item.Benutzer === "SHRahimi" || item.Benutzer === "Sara Haj Rahimi"
        );
        setActivityStats(sortedactivity);
      });
  }

  function changeActivityFilter(activity) {
    console.log(activityFilter);
    setActivityFilter((prev) => ({ ...prev, [activity]: !prev[activity] }));
  }

  return (
    <>
      {activityStats && (
        <>
          <div className="text-center">
            <ButtonGroup className="" aria-label="First group">
              <Button
                style={{
                  backgroundColor: activityFilter.Telefonat ? "#aa0" : "#000",
                }}
                onClick={(e) => changeActivityFilter("Telefonat")}
              >
                Telefonat
              </Button>
              <Button
                style={{
                  backgroundColor: activityFilter.Email ? "#a0a" : "#000",
                }}
                onClick={(e) => changeActivityFilter("Email")}
              >
                Email
              </Button>
              <Button
                style={{
                  backgroundColor: activityFilter.Termin ? "#0aa" : "#000",
                }}
                onClick={(e) => changeActivityFilter("Termin")}
              >
                Termin
              </Button>
              <Button
                style={{
                  backgroundColor: activityFilter.Einkaufstermin
                    ? "#a00"
                    : "#000",
                }}
                onClick={(e) => changeActivityFilter("Einkaufstermin")}
              >
                Einkaufstermin
              </Button>
              <Button
                style={{
                  backgroundColor: activityFilter.Bewertungsmappentermin
                    ? "#500"
                    : "#000",
                }}
                onClick={(e) => changeActivityFilter("Bewertungsmappentermin")}
              >
                Bewertungsmappentermin
              </Button>
              <Button
                style={{
                  backgroundColor: activityFilter.Akquiseanruf_erreicht
                    ? "#00a"
                    : "#000",
                }}
                onClick={(e) => changeActivityFilter("Akquiseanruf_erreicht")}
              >
                Akquiseanruf erreicht
              </Button>
              <Button
                style={{
                  backgroundColor: activityFilter.Akquiseanruf_nicht_erreicht
                    ? "#0a0"
                    : "#000",
                }}
                onClick={(e) =>
                  changeActivityFilter("Akquiseanruf_nicht_erreicht")
                }
              >
                Akquiseanruf nicht erreicht
              </Button>
            </ButtonGroup>
            <div className="oneline-datepicker">
              <strong className="me-2 mt-2">Zeitspanne: </strong>
              <DatePicker
                selected={startDate}
                onChange={onDateRangeChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                className="custom-date-oneline-inputfield mt-2"
                calendarClassName="custom-date-calendar"
                dateFormat="dd.MM.yyyy"
                locale="de"
              />
            </div>
          </div>
          <div className="scrollcontainer">
            <StatistikZeitverlauf
              heading="Aktivitäten Halder"
              data={activityStats.chalder}
              filter={activityFilter}
            />
            <StatistikZeitverlauf
              heading="Aktivitäten Linkh"
              data={activityStats.dlinkh}
              filter={activityFilter}
            />
            <StatistikZeitverlauf
              heading="Aktivitäten Schimminger"
              data={activityStats.tschimminger}
              filter={activityFilter}
            />
            <StatistikZeitverlauf
              heading="Aktivitäten SHRahimi"
              data={activityStats.shrahimi}
              filter={activityFilter}
            />
          </div>
        </>
      )}
    </>
  );
}

export default StatistikActivity;
